import { Component, effect, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AppStateService } from './core/services/app-state.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { PaginatorCustom } from './shared/utils/PaginatorCustom.utils';

@Component({
  selector: 'pec-root',
  standalone: true,
  imports: [RouterOutlet],
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: PaginatorCustom,
    },
  ],
  template: '<router-outlet />',
})
export class App implements OnInit {
  private readonly state = inject(AppStateService);
  private readonly snackBar = inject(MatSnackBar);

  authService = inject(AuthService);

  constructor() {
    const iconRegistry = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);

    iconRegistry.addSvgIcon(
      'node',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/tree_final.svg'),
    );
    iconRegistry.addSvgIcon(
      'folder',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/tree_folder.svg'),
    );

    effect(() => {
      const toast = this.state.toast();
      if (toast) {
        this.snackBar.open(toast.message, 'OK', {
          duration: 4000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
          panelClass: `toast-${toast.type}`,
        });
      }
    });
  }

  ngOnInit(): void {
    this.authService.handleCognitoToken();
  }
}
